import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayFilter',
})
export class ArrayFilterPipe implements PipeTransform {
  transform<T>(
    list: T[],
    field: keyof T,
    value: any | any[],
    include = true
  ): T[] {
    return list.filter((item) => {
      if (Array.isArray(value)) {
        return include
          ? value.includes(item[field])
          : !value.includes(item[field]);
      } else {
        return include ? item[field] === value : item[field] !== value;
      }
    });
  }
}
